// import { get } from 'react-hook-form';

// const API_BASE_URL = 'http://127.0.0.1:3000/api/v1';
const API_BASE_URL = 'https://medic-bd-api.onrender.com/api/v1';

// Get auth token from localStorage
const getAuthToken = () => localStorage.getItem('token');

// Common headers with authentication
const getHeaders = () => {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

// Handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    // Check for unauthorized access
    if (response.status === 401) {
      // Clear invalid token and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      throw new Error('Authentication failed. Please login again.');
    }
    throw new Error(`Error: ${response.status} - ${response.statusText}`);
  }

  // Handle 204 No Content responses
  if (response.status === 204) {
    return null;
  }

  return response.json();
};

// FETCH specializations
const fetchspecializations = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/specializations`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    // console.error('Error fetching specializations:', error);
    return [];
  }
};

// FETCH CHAMBERS BY DISTRICT ID AND CATEGORY
const fetchChambers = async (category, districtId) => {
  try {
    const url = `${API_BASE_URL}/chambers?category=${category}&district_id=${districtId}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    console.error(`Error fetching ${category} data:`, error);
    return [];
  }
};

// FETCH FILTERED DOCTORS BY specialization ID AND district ID
const fetchFilteredDoctors = async (specializationId, districtId) => {
  const url = `${API_BASE_URL}/doctors/by_specialization_query?specialization_id=${specializationId}&district_id=${districtId}`;
  const response = await fetch(url);
  console.log('Response:', response);
  if (!response.ok) {
    // Parse error response for more details from Rails server
    const errorData = await response.json();
    // Throw an error with specific message from the server
    throw new Error(errorData.message || `Error: ${response.status} - ${response.statusText}`);
  }
  return response.json();
};

// FETCH DOCTORS BY specialization ID
const fetchDoctorsByspecializationId = async (specializationId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/doctors/filtered_doctors?specialization_id=${specializationId}`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    // const data = await response.json();
    // if (Array.isArray(data)) {
    //   return data;
    // }
    // return [data];

    return response.json();
  } catch (error) {
    // console.error('Error fetching doctors:', error);
    return [];
  }
};

// FETCH ALL DOCTORS
const fetchDoctors = async () => {
  const response = await fetch(`${API_BASE_URL}/doctors`);
  const data = await response.json();
  return data;
};

// FETCH DOCTOR BY ID
const fetchDoctorById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/doctors/${id}`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
    // console.log('Doctor by id:', response);
  } catch (error) {
    // console.error('Error fetching doctor by id:', error);
    return {};
  }
};

// FETCH DOCTOR BY ORDER
const fetchDoctorByOrder = async (order) => {
  if (!order) {
    console.error('Order is required to fetch a doctor.');
    return null;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/doctors/order/${order}`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    console.log('Doctor by order:', response);

    return response.json();
  } catch (error) {
    console.error('Error fetching doctor by order:', error);
    return null;
  }
};

// ADD NEW DOCTOR
const addDoctor = async (doctor) => {
  try {
    const response = await fetch(`${API_BASE_URL}/doctors`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(doctor),
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    // console.error('Error adding doctor:', error);
    return null;
  }
};

// UPDATE DOCTOR
const updateDoctor = async (doctorData) => {
  console.log('Received doctor data:', doctorData);

  const doctor = doctorData?.doctor;

  if (!doctor || !doctor.id) {
    console.error('Doctor ID is missing or invalid!');
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/doctors/${doctor.id}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify({ doctor }),
    });
    console.log('Raw response:', response);

    if (response.ok) {
      if (response.status === 204) {
        // No content to parse, just return a success message
        console.log('Update successful: No Content returned');
        console.log('Update successful: No Content returned');
      }

      const result = await response.json(); // If response contains data
      console.log('Update successful:', result);
      // Removed return statement as the function is not expected to return a value
    }
    console.error('HTTP Error:', response.status, response.statusText);
    const errorText = await response.text();
    console.error('Response text:', errorText);
    throw new Error('Failed to update the doctor');
  } catch (error) {
    console.error('Error updating doctor:', error);
  }
};

// FETCH Feedbacks
const fetchFeedbacks = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/user_feedbacks`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    // console.error('Error fetching feedbacks:', error);
    return [];
  }
};

// CREATE NEW Feedback
const createFeedback = async (feedback) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user_feedbacks`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(feedback),
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    // console.error('Error creating feedback:', error);
    return null;
  }
};

// FETCH DISTRICTS
const fetchDistricts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/districts`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    // console.error('Error fetching districts:', error);
    return [];
  }
};

// EXPORTS
export {
  fetchspecializations,
  fetchFilteredDoctors,
  fetchChambers,
  fetchDoctorsByspecializationId,
  fetchDoctors,
  fetchDoctorById,
  fetchDoctorByOrder,
  addDoctor,
  fetchFeedbacks, createFeedback, fetchDistricts,
  updateDoctor,
  getAuthToken, getHeaders, handleResponse,
};
